
import React, { useState, useEffect, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import Slide from '@mui/material/Slide';
import TextField from '@mui/material/TextField';
import SaveOutlined from '@mui/icons-material/SaveOutlined';
import { useForm, Controller } from "react-hook-form";
import Typography from '@mui/material/Typography';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem'
import LocationPicker from '../../Utils/locationpicker'; 
import Select from '@mui/material/Select';
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import { simulateAsset,GetSimulateAsset, UpdateSimulateAsset,GetSimulateAssetfields } 
      from "../../REST/assets"; // Adjusted API for assets
import { createAssetLink } from "../../helpers"; 
import {FieldConfigForm,FieldConfigYup} from "../../Utils/fieldconfigs"
import { useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(props, ref) {
return <Slide direction="up" ref={ref} {...props} />;
});

const MasterAddEditAssetData = ({id, handleClose,assetTypes,location,assetId})=>{

    const isAdd = typeof id == "undefined"
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();
    const [schema,setSchema] = useState(yup.object({}))
    const [loaded, setLoaded] = useState(false);
    const [config,setConfig] = useState(null)
    const frame = useRef(null)
    const [formData, setFormData] = useState(null);
    const [saving,setSaving] = useState(false)
  
    const { control, register, handleSubmit, clearErrors, reset, formState: { errors } } = useForm({
      defaultValues: {
       
        status:true,
        location:{lon:-119.734,lat: 39.193},
         
      },
      resolver: yupResolver(schema)
    });
    

    const LocationPickerControl = ({ errors, field }) => {
       
      const { name } = field;
      return (
        <FormControl required error={Boolean(errors[name])} variant="standard" margin="dense" fullWidth>
            
              <LocationPicker {...register(name)}
                
                {...field}
                
              />
              {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
        </FormControl>
      );
    }
    useEffect(() => {
      GetSimulateAssetfields()
      .then((r)=>{
        setConfig(r.data)
        const newschema = {
          ...FieldConfigYup(r.data),
          ...{
            assetId:yup.string().trim().required("Choose an asset type"),
            status:yup.boolean().required(),
            location:yup.object({
              lat: yup.number().required(),
              lon: yup.number().required()})
          }
        } 
        setSchema(yup.object(newschema))
        if(isAdd)
          {
              setFormData({})
              reset({ location:location,assetId:assetId || '',status:true });
              setLoaded(true)
          }
          else
          {
              GetSimulateAsset(id) 
              .then((res) => {
                  
                  setFormData(res.data);  
                  let updatedfields = ["status","assetId","location"]
                  updatedfields = updatedfields.concat(r.data.map((t)=>t.fieldName))
                  const finaldata  = {}
                  updatedfields.forEach((t)=>{
                    finaldata[t] = res.data[t]
                  })
                  reset(finaldata);
                  setLoaded(true);                
                })
                .catch((e) => { navigate("/asset") });
          }    
         
      })
       
     
    }, [id, assetId, reset, handleClose]);
    const saveFrame = ()=>{
      frame.current.contentWindow.postMessage("callSave","*");


      return new Promise((resolve, _) => {
        setTimeout(()=>{
         
          resolve()
          
        },3000)
      })

      
      
    }
    const isError = (val) => val !== undefined && val !== null && typeof val === 'object';
  
    const saveForm = (r) => {
       
        let record = {
            ...r,data:{}, 
        }
       
       simulateAsset(record)    
       .then(handleClose)	
    };
    const updateForm = (r) => {
        if(saving) return

        setSaving(true) 
        let record = {
          ...formData, ...r
        }; 

        delete record.data

        saveFrame()
        .then(()=>{ return   UpdateSimulateAsset(id, record) })    
        .then((d)=>{
          setSaving(false) 
          handleClose(d)
        });	
      };
    
    if (!loaded) return (<></>);
  
    return (
      <Dialog
        fullScreen={isMobile}
        sx={isMobile ? undefined : {
          '& .MuiDialog-paper': {
            width: 'min(1200px, 100%)',
            maxWidth: 'none',
            height: 'calc(100% - 32px)',
            maxHeight: 'none',
            margin: 2,
            marginLeft: 'auto',
            borderRadius: 2,
          },
        }}
        open={true}
        onClose={() => { handleClose(); }}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar style={{ justifyContent: 'space-between' }}>
            <IconButton edge="start" color="inherit" onClick={() => { handleClose(); }} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {isAdd ? "Add New ":"Update "+"Asset"}
            </Typography>
            <IconButton edge="start" color="inherit" onClick={handleSubmit(isAdd ? saveForm : updateForm)} >
              {
                saving ? (     <CircularProgress color='error' />  ) : (    <SaveOutlined />       )
              }
              
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box
          display="flex"
          width="100%"
          flex="1 1 auto"
          flexDirection={isMobile ? 'column' : 'row'}
          minHeight={0}
          sx={{
            overflow: 'hidden',
          }}
        >
          
          <Box
            height={isMobile ? 'auto' : '100%'}
            width={isMobile ? '100%' : (isAdd ? '100%' : '32%')}
            p={2}
            sx={{
              flex: isMobile ? '0 0 auto' : '0 0 auto',
              overflowY: 'auto',
              borderRight: !isMobile && !isAdd ? `1px solid ${theme.palette.divider}` : 'none',
              borderBottom: isMobile && !isAdd ? `1px solid ${theme.palette.divider}` : 'none',
            }}
          >
           <Controller  
                name="assetId" control={control}
                error={isError(errors.assetId)} helperText={errors.assetId && errors.assetId.message}
                render={({ field }) => (
                  <>
                    <Select
                      {...field}
                      required
                      margin="dense"
                      error={isError(errors.assetId)}
                      fullWidth
                      label="Asset Type" 
                    >
                      {assetTypes.map((each) => {
                        const { name, _id } = each;
                        return (
                          <MenuItem key={_id} value={_id}>
                            {name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    {errors.assetId && (
                      <FormHelperText error>{errors.assetId.message}</FormHelperText>
                    )}
                  </>
                )}
           /> 
         <FieldConfigForm  fieldConfig = {config}  control={control} />
          <Controller
          name="location"
          control={control}
          render={({ field }) => <LocationPickerControl errors={errors} field={field}   />}
        /> 
        </Box>
        {
          !isAdd && (
            <Box
              width={isMobile ? '100%' : '68%'}
              height={isMobile ? 'auto' : '100%'}
              padding={2}
              sx={{
                flex: isMobile ? '1 1 360px' : '1 1 auto',
                minHeight: 0,
                minWidth: 0,
              }}
            >
          
            <iframe src={createAssetLink(id,true)} ref={frame}  
                        frameBorder="0"
                        marginHeight="0"
                        marginWidth="0"
                        width="100%"
                        height="100%"
                        title='Template Editor'
                        scrolling="auto" />
                
            </Box>   
          )
        }
       
      </Box>    
      </Dialog>

    );
  
 
    

}      
export default MasterAddEditAssetData
